let isValidPhoneNumber = null;

export const loadPhoneValidation = () =>
  import("libphonenumber-js/min").then((mod) => {
    isValidPhoneNumber = mod.isValidPhoneNumber;
  });

export const isValidPhone = (raw) => {
  const val = (raw || "").trim();
  if (!val.startsWith("+")) return false;
  if (!isValidPhoneNumber) return /^\+\d{8,15}$/.test(val);
  try {
    return isValidPhoneNumber(val);
  } catch {
    return false;
  }
};
